import Model, { attr, belongsTo } from '@ember-data/model';
import { service } from '@ember/service';

export default class UserDocumentTemplateAttachment extends Model {
  @service intl;

  @belongsTo('user-document-template', { async: false, inverse: 'userDocumentTemplateAttachments' })
  userDocumentTemplate;
  @belongsTo('user-document-attachment', { async: false, inverse: 'userDocumentTemplateAttachment' })
  userDocumentAttachment;

  @attr('boolean') required;
  @attr('number') position;
  @attr('string') description;
  @attr('string') identifier;
  @attr('string') title;

  get localizedTitle() {
    return this.intl.t(`documents.attachments.title:${this.identifier}`) || this.title;
  }

  get localizedDescription() {
    return this.intl.t(`documents.attachments.description:${this.identifier}`) || this.description;
  }
}
